import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";
import back from "../../back.png";
import InputPassword from "../../helpers/InputPassword";
import InputCombo from "../../helpers/InputCombo";
import InputText from "../../helpers/InputText";


function Account(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [row, setRow] = useState(null); 

    

    const valChangeListener = (filedName, val, correct, msg) => {   
        
            
                //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
              
            
                row[filedName] = val;
                row[filedName+"_valid"] = correct;         
 
                setRow(  JSON.parse(JSON.stringify(row)) );    
             
            } 

        const onBack = ( ) => {                
                
            }


        const onSuccess = ( ) => {                
                
                getUserDet();
        }


        const getUserDet = () => {
                    
            
                    props.mainView.showProgress();

                    fetch( Config.url + '/rest_v1,user_det', {
                        method: 'POST', 
                        body: JSON.stringify( ), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                                 props.mainView.hideProgress();

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                }else    
                                {
                                    setRow(res.result);                                                 
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                props.mainView.hideProgress();
                    });
                            

                    return false;
                }


        const valChecker = (fields) => {

        var allValid = true;

              
        console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                if(Config.env == 'dev') console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


       const validate = (pw) => { 

        return /[A-Z]/.test(pw) &&
        /[a-z]/       .test(pw) &&
        /[0-9]/       .test(pw) &&
        /[^A-Za-z0-9]/.test(pw) &&
        pw.length > 5;

        
      };


        const saveData = () => {
                
 
              if(row.password.length > 0 )
              {

                  if(row.password.length < 8) {
                         props.mainView.showDialog("Ups!" , "Hasło musi zawierać min. 8 znaków."  ,  "error"  ,null); 
                         return;
                  }

                  if(row.password2.length < 8  ||  row.password != row.password  ) {
                         props.mainView.showDialog("Ups!" , "Powtórz poprawnie hasło"  ,  "error"  ,null); 
                         return;
                  }

                  if(validate(row.password) == false)
                  {
                         props.mainView.showDialog("Ups!" , "Hasło musi zawierać min. 8 znaków, cyfry i litery"  ,  "error"  ,null); 
                         return;
                  }


              }


              
             if(!valChecker(row))
                {
                        props.mainView.showDialog("Ups!" , "Wypełnij prawidłowo pola formularza"  ,  "error"  ,null); 
                        return;
                }
                




                  props.mainView.showProgress();
 

                    fetch( Config.url + '/rest_v1,user_update', {
                        method: 'POST', 
                        body: JSON.stringify(row), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                            
                                props.mainView.hideProgress();

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                }else    
                                {
                                    props.mainView.showDialog( "Sukces",  "Dane zostały zapisane.", "ok" , (pp)=>{
                                           
                                    } );                                                  
                                                                
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                props.mainView.hideProgress();
                    });
                        


                

                return false;
            }


        if(refreshView != props.userData.refreshView)
        {     
            setRefreshView(props.userData.refreshView);       
            getUserDet();
        }



        if(row == null)
        {
            setRow([]);
            getUserDet();
            return <div>
                ...
            </div>
        }

        if(row.imie == undefined)
        {
            return <div>.....</div>
        }

    

        return <div className="view_content">

                    <div className="app_header">{row.imie} {row.nazwisko} / Login: {row.login}</div>

                      <form className="eForm bg_center">

                            <div className="form_tab_title">Autoryzacja:</div>

                            <div className="form_tab">
                                            <div className="form_control">
                                                <div className="fieldName">Hasło (min. 8 znaków, DUŻE, małe litery, cyfry, znaki specjalne)</div>
                                                <InputPassword   userData={props.userData} value={row.password} err={null}  valChange={valChangeListener} goNext={null} name="password" placeholder={"Nowe hasło:"} className=' w300 ' req='0' firstUp="0" />
                                            </div>

                                             <div className="form_control">
                                                <div className="fieldName">Powtórz hasło</div>
                                                <InputPassword   userData={props.userData} value={row.password2} err={null}  valChange={valChangeListener} goNext={null} name="password2" placeholder={"Powtórz nowe hasło:"} className=' w300 ' req='0' firstUp="0" />
                                            </div>
                            </div>


                            <div className="form_split"></div>

                            <div className="form_btn">
                                        <div className="btn" onClick={saveData}>zapisz zmiany</div>                                       
                            </div>



                            <div className="form_tab_title">Dodatkowe zabezpieczenia:</div>

                            <div className="form_tab">

                                            <div className="form_control">
                                                <div className="fieldName">Autoryzacja dwuetapowa</div>
                                                <InputCombo items={[ {v:'1',title: 'Tak'}, {v:'0',title: 'Nie'},   ]}   userData={props.userData} value={row.f2} err={null}  valChange={valChangeListener} goNext={null} name="f2" placeholder={":"} className='  ' req='0' firstUp="0" />
                                            </div>

                                             <div className="form_control">
                                                <div className="fieldName">Logowanie tylko z IP: (np. x.x.x.x, y.y.y.y) </div>
                                                <InputText   userData={props.userData} value={row.ip_s} err={null}  valChange={valChangeListener} goNext={null} name="ip_s" placeholder={"IP:"} className=' w300 ' req='0' firstUp="0" />
                                            </div>
                            </div>


                            <div className="form_split"></div>

                            <div className="form_btn">
                                        <div className="btn" onClick={saveData}>zapisz zmiany</div>                                       
                            </div>




                      </form>

        </div>
}


export default Account;